'use client';
import React from 'react';
import Image from 'next/image';
import sanitizeHtml from 'sanitize-html';
import { useIsMobile } from '@/hooks/useIsMobile';

const sanitizeAndRenderHtml = (
  content: string | undefined
): { __html: string } | undefined => {
  if (!content) return undefined;

  const sanitized = sanitizeHtml(content, {
    allowedAttributes: {
      span: ['class'],
    },
    allowedClasses: {
      span: ['*'], // Allow all classes on span elements
    },
    allowedTags: ['b', 'strong', 'i', 'em', 'u', 'span', 'br', 'p'],
  });

  return { __html: sanitized };
};

interface OurStoryHeroProps {
  mainHeading?: string;
  subtitle?: string;
  tagline?: string;
  mobileImageAlt?: string;
  desktopImageAlt?: string;
}

export default function OurStoryHero({
  desktopImageAlt = '',
  mainHeading = 'Our Story',
  mobileImageAlt = '',
  subtitle = "F*ck it, We'll Do It Ourselves",
  tagline = '(aka the trusti™ Origin Story)',
}: OurStoryHeroProps) {
  const isMobile = useIsMobile();
  return (
    <section className="page-top-spacing-hero mt-3 flex w-full flex-col items-center py-[48px] md:py-[24px]">
      <div className="content-wrapper flex flex-col lg:flex-row lg:justify-between">
        <div>
          <h1
            className="mb-8 text-[44px]"
            dangerouslySetInnerHTML={sanitizeAndRenderHtml(mainHeading)}
          />
          {!isMobile && (
            <>
              <h3
                className="subheadingFour"
                dangerouslySetInnerHTML={sanitizeAndRenderHtml(subtitle)}
              />
              <span
                className="bodyTextDescription"
                dangerouslySetInnerHTML={sanitizeAndRenderHtml(tagline)}
              />
            </>
          )}
        </div>
        <Image
          src="/our-story-mobile.jpg"
          height={620}
          width={400}
          alt={mobileImageAlt}
          className="mt-4 mb-8 block rounded-[10px] sm:hidden"
          sizes="(max-width: 640px) 100vw, 0px"
          placeholder="blur"
          blurDataURL="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAABAAEDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAv/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAX/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwCdABmX/9k="
        />
        {isMobile && (
          <div className={'max-[635]:px-4'}>
            <h3
              className="subheadingFour"
              dangerouslySetInnerHTML={sanitizeAndRenderHtml(subtitle)}
            />
            <span
              className="bodyTextDescription"
              dangerouslySetInnerHTML={sanitizeAndRenderHtml(tagline)}
            />
          </div>
        )}
        <div className="hidden w-full max-w-[720px] sm:block">
          <Image
            src="/ourStoryHeaderImage.png"
            height={426}
            width={862}
            alt={desktopImageAlt}
            className="mt-4 lg:mt-0"
            sizes="(max-width: 640px) 0px, min(100vw, 720px)"
            placeholder="blur"
            blurDataURL="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAABAAEDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAv/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAX/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwCdABmX/9k="
          />
        </div>
      </div>
    </section>
  );
}
